/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ConsentsPurpose {
  Id?: string;
  LastReceiptId?: string;
  /**
   * Possible values are:   VERTI_ITALY_GUIDEWIRE_PRIVACY_POLICY   VERTI_ITALY_MARKETING RESEARCH   VERTI_ITALY_BUSINESS_COMMUNICATIONS   VERTI_ITALY_GUIDEWIRE_PROFILING   VERTI_ITALY_COMARKETING
   */
  Name?: ConsentsPurpose.NameEnum;
  Version?: string;
  Status?: string;
  FirstTransactionDate?: Date;
  LastTransactionDate?: Date;
  WithdrawalDate?: Date;
  ConsentDate?: Date;
  ExpiryDate?: Date;
  TotalTransactionCount?: string;
  LastTransactionCollectionPointId?: string;
  LastTransactionCollectionPointVersion?: string;
  PurposeNote?: string;
  LastUpdatedDate?: string;
  LastInteractionDate?: Date;
}
export namespace ConsentsPurpose {
  export type NameEnum =
    | 'VERTI_ITALY_GUIDEWIRE_PRIVACY_POLICY'
    | 'VERTI_ITALY_MARKETING RESEARCH'
    | 'VERTI_ITALY_BUSINESS_COMMUNICATIONS'
    | 'VERTI_ITALY_GUIDEWIRE_PROFILING'
    | 'VERTI_ITALY_COMARKETING';
  export const NameEnum = {
    GUIDEWIREPRIVACYPOLICY: 'VERTI_ITALY_GUIDEWIRE_PRIVACY_POLICY' as NameEnum,
    MARKETINGRESEARCH: 'VERTI_ITALY_MARKETING RESEARCH' as NameEnum,
    BUSINESSCOMMUNICATIONS: 'VERTI_ITALY_BUSINESS_COMMUNICATIONS' as NameEnum,
    GUIDEWIREPROFILING: 'VERTI_ITALY_GUIDEWIRE_PROFILING' as NameEnum,
    COMARKETING: 'VERTI_ITALY_COMARKETING' as NameEnum,
  };
}
